export const defaultRadioCellContentProps = {
  align: 'center',
  width: '100px',
};
